import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';

export const MenuItemComponent = ({ item, props }: any) => {
  return (
    <li className="nav-item">
      {item.link ? (
        <Link
          className="nav-link menu-link"
          onClick={item.click}
          to={item.link}
          data-bs-toggle={item.subItems.length > 0 ? 'collapse' : undefined}
          aria-expanded={item.stateVariables ? 'true' : 'false'}
        >
          {item.icon && <i className={item.icon}></i>}
          <span>{props.t(item.label)}</span>
        </Link>
      ) : (
        <a
          className="nav-link menu-link"
          onClick={item.click}
          data-bs-toggle={item.subItems.length > 0 ? 'collapse' : undefined}
          aria-expanded={item.stateVariables ? 'true' : 'false'}
          style={{ cursor: 'pointer' }}
        >
          {item.icon && <i className={item.icon}></i>}
          <span>{props.t(item.label)}</span>
        </a>
      )}

      {item.subItems.length > 0 && (
        <Collapse
          className="menu-dropdown"
          isOpen={item.stateVariables}
          id={`collapse-${item.id}`}
        >
          <ul className="nav nav-sm flex-column">
            {item.subItems.map((subItem) => (
              <MenuItemComponent
                key={subItem.id}
                item={subItem}
                props={props}
              />
            ))}
          </ul>
        </Collapse>
      )}
    </li>
  );
};
